import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { SqlService } from "../../Database/sql.service";

import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';


import Swal from 'sweetalert2';

@Component({
  selector: 'app-transfer-branch',
  templateUrl: './transfer-branch.component.html',
  styleUrls: ['./transfer-branch.component.css']
})
export class TransferBranchComponent implements OnInit {

  BoxNumber = "";

  Branch = "";
  Branchs = [""];

  closeResult = '';
  DisplayErrormessage = "";
  PopupTitle = "";
  ConfirmReset = "";

  PossibleBoxNumbers = [""];
  PossibleBox = "";
  constructor(private dbService: SqlService, private router: Router, private modalService: NgbModal) { }

  ngOnInit(): void {

    Swal.fire({
      title: 'Loading Branches...',
      showConfirmButton: false,
      toast: false,
      allowOutsideClick: false, 
      allowEscapeKey: false,
      willOpen: () => {
        Swal.showLoading();
      }
    });

    this.getData();

    this.GetAllBoxNames(" 1=1 ");
  }

  PossibleBoxChanged() {
    this.BoxNumber = this.PossibleBox[0];
  }


  BoxNameChanged() {
    this.GetAllBoxNames(" [Pactel].[dbo].[Boxes].Boxno like '" + this.BoxNumber + "%' ");
  }

  GetAllBoxNames(condition: string) {
    Swal.fire({
      title: 'Loading Boxes',
      showConfirmButton: false,
      toast: false,
      allowOutsideClick: false, 
      allowEscapeKey: false,
      willOpen: () => {
        Swal.showLoading();
      }
    });

    this.PossibleBoxNumbers.splice(0);


    let formData = new FormData(); // Currently empty
    formData.set("Where", condition);

    (this.dbService.getTopBoxesNames(formData).subscribe((ret: any) => {
      if (ret != "false") {

        (ret as string).split(';').forEach(element => {
          this.PossibleBoxNumbers.push(element);
        });

        Swal.close();
      } else {
        this.PopupTitle = "Error"
        this.DisplayErrormessage = "Please check your internet connection and try again";
        let element: HTMLButtonElement = document.getElementById('ErrorButton') as HTMLButtonElement;
        element.click();
        Swal.close();
      }
    }));
  }


  getData() {
    this.dbService.GetAllBranches().subscribe((ret: any) => {
      if (ret != "false") {
        this.Branchs.splice(0);
        let a = (ret as string).split(';');
        a.splice(a.length - 1, 1);

        a.forEach(element => {
          this.Branchs.push(element);
        });
        Swal.close();
      } else {
        alert("Please check your connection and try again");
        Swal.close();
      }
    });
  }

  Save() {
    Swal.fire({
      title: 'transferring box...',
      showConfirmButton: false,
      toast: false,
      allowOutsideClick: false, 
      allowEscapeKey: false,
      willOpen: () => {
        Swal.showLoading();
      }
    });

    this.dbService.TransferBranch(this.BoxNumber, this.Branch).subscribe((ret: any) => {
      if (ret != "false") {
        this.PopupTitle = "Success"
        this.DisplayErrormessage = "The Box has been transferred";
        let element: HTMLButtonElement = document.getElementById('ErrorButton') as HTMLButtonElement;
        this.Reset();
        element.click();
        Swal.close();
      } else {
        this.PopupTitle = "Error"
        this.DisplayErrormessage = "Please check your internet connection and try again";
        let element: HTMLButtonElement = document.getElementById('ErrorButton') as HTMLButtonElement;
        element.click();
        Swal.close();
      }
    });
  }


  Reset() {
    this.BoxNumber = "";
    this.Branch = "";

    this.GetAllBoxNames(" 1=1 ");
  }

  open(content: any) {
    this.modalService.open(content,
      { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
        this.closeResult = `Closed with: ${result}`;
      }, (reason) => {
        this.closeResult =
          `Dismissed ${this.getDismissReason(reason)}`;
        //let element: HTMLButtonElement = document.getElementById('ErrorButton') as HTMLButtonElement;
        //element.click();
      });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
}
